export default "__VITE_ASSET__z1PX0WmX__"